import { appState } from './stateManager';
import DataManager from './dataManager';
// import LeafletMap from './map';
import Timeline from './timeline';
import Filters from './filters';
import { INTENSITIES, MARTIAL_STRUCTURE, normalize } from './details';
import Scene from './scene';
import Info from './info';
import About from './about';

export default class App {
	constructor() {
		this.hasInited = false;
		this.previousStateCopy = null;
		this.scene;
	}

	init() {
		appState.subscribe(this.onStateChange.bind(this));

		const dataManager = new DataManager();
		dataManager.init();
	}

	onStateChange(state) {
		if (!this.hasInited && state.data.length) {
			// const map = new LeafletMap();
			// map.init();
			const about = new About();
			about.init();
			const scene = new Scene();
			scene.init();
			this.scene = scene;
			const timeline = new Timeline();
			timeline.init();
			const filters = new Filters();
			filters.init();
			const info = new Info();
			info.init();
			this.hasInited = true;

			document.getElementById('loading')?.classList.add('hide');
			console.log('init');
		}

		this.filter(state);
	}

	filter(state) {
		const { data, time, searchQuery, intensities, martialKeys, days, tanks, victims, airStrike } = state;
		const previousState = {
			time,
			searchQuery,
			intensities,
			martialKeys,
			days,
			tanks,
			victims,
			airStrike
		};
		const previousStateCopy = JSON.stringify(previousState);
		if (this.previousStateCopy === previousStateCopy) return;
		this.previousStateCopy = previousStateCopy;

		const { presentIds, pastIds, visibleIds } = this.getStateIds(
			data,
			time,
			searchQuery,
			intensities,
			martialKeys,
			victims,
			days,
			tanks,
			airStrike
		);
		const currentState = appState.getState();
		appState.setState({
			...currentState,
			presentIds,
			pastIds,
			visibleIds,
			id: -1,
			hoverId: -1
		});
	}

	getStateIds(data, time, searchQuery, intensities, martialKeys, victims, days, tanks, airStrike) {
		const presentIds = new Set();
		const pastIds = new Set();
		const visibleIds = new Set();
		for (const item of data) {
			// properties
			const id = item.id;
			const startTimestamp = item.start_time;
			const endTimestamp = item.end_time;
			const name = normalize(item['A település mai neve'] || '') || '';
			const intensity = item['A harctevékenység átlagos intenzitása']?.trim() || '';
			const itemMartialKeys = [...item.tamado_keys.flat(), ...item.vedo_keys.flat()];
			const itemVictims = item.numRecords || null;
			const itemDays = parseInt(item['A harctevékenység időtartama (naptári nap)']) || null;
			const itemTanks = parseInt(item['Páncélosok alkalmazása']) || null;
			const itemAirStrike = item.hasAirStrike || false;

			// checks
			const isPresentInSearch = searchQuery == '' || name.includes(searchQuery);
			const isPresentMartial =
				!itemMartialKeys.length ||
				!itemMartialKeys.some((itemMartialKey) => MARTIAL_STRUCTURE.nemzetiség.includes(itemMartialKey)) ||
				itemMartialKeys.some((itemMartialKey) => martialKeys.includes(itemMartialKey));
			const isPresentIntensity =
				!intensity || !INTENSITIES.includes(intensity) || intensities.includes(intensity);
			const isPresentVictims =
				(itemVictims == null && victims[0] === 0) || (itemVictims >= victims[0] && itemVictims <= victims[1]);
			const isPresentDays = (itemDays == null && days[0] === 0) || (itemDays >= days[0] && itemDays <= days[1]);
			const isPresentTanks =
				(itemTanks == null && tanks[0] === 0) || (itemTanks >= tanks[0] && itemTanks <= tanks[1]);
			const isPresentAirStrike = airStrike.includes(itemAirStrike);
			const isPast =
				(startTimestamp != null && endTimestamp == null && time > startTimestamp) ||
				(startTimestamp == null && endTimestamp != null && time > endTimestamp) ||
				(startTimestamp != null && endTimestamp != null && time > startTimestamp && time > endTimestamp);
			const isPresent =
				(startTimestamp != null && startTimestamp === time) ||
				(endTimestamp != null && endTimestamp === time) ||
				(startTimestamp != null && endTimestamp != null && time >= startTimestamp && time <= endTimestamp);

			// add to indices
			if (
				isPresentInSearch &&
				isPresentMartial &&
				isPresentIntensity &&
				isPresentVictims &&
				isPresentDays &&
				isPresentTanks &&
				isPresentAirStrike
			) {
				if (isPresent) {
					presentIds.add(id);
					visibleIds.add(id);
				} else if (isPast) {
					pastIds.add(id);
					visibleIds.add(id);
				} else {
					// FUTURE but filtered → visible but not colored
					visibleIds.add(id);
				}
			}
		}
		return {
			presentIds,
			pastIds,
			visibleIds
		};
	}
}
